import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import Text from 'components/Text';
import BulletList from 'components/BulletList';
import SimpleModal from 'components/SimpleModal';
var infoTranslationKeys = ['modal_optional_content_info_1', 'modal_optional_content_info_2'];
export default function OptionalContentModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('modal_optional_content_title'),
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "m"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_optional_content_intro')), /*#__PURE__*/React.createElement(BulletList, null, infoTranslationKeys.map(function (key) {
      return t(key);
    })), /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_optional_content_outro'))),
    buttons: [{
      label: t('actions_got_it'),
      onClick: onClose
    }],
    onClose: onClose
  });
}